import { render, staticRenderFns } from "./TextHeading2.vue?vue&type=template&id=7cf97cb8&scoped=true"
import script from "./TextHeading2.vue?vue&type=script&lang=js"
export * from "./TextHeading2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf97cb8",
  null
  
)

export default component.exports